export const serverCore = process.env.REACT_APP_API_URI || 'https://api.srovnejsito.eu';
export const authorizatorURI = process.env.REACT_APP_AUTHORIZATOR_URI || 'https://auth.srovnejsito.eu';
export const tenantId = process.env.REACT_APP_TENANT_ID || 'srovnejsito.eu';
export const server = serverCore + '/api';
